export const center_app_version = {"commit_sha": "92bdee5"}
